import React from 'react';
import { useConnect } from '@lore/query-connect';
import UserRole from './UserRole';
import UserJob from './UserJob';

const MAX_ROLES = 2;

export default function UserRolesAndJobs(props) {
  const { user } = props;

  const _roles = useConnect('role.find', {
    where: {
      eager: {
        $where: {
          userId: user.id
        }
      }
    },
    pagination: {
      page: 1,
      pageSize: 100,
      order: 'createdAt asc'
    }
  });

  const _jobs = useConnect('job.find', {
    where: {
      eager: {
        $where: {
          userId: user.id
        }
      }
    },
    pagination: {
      page: 1,
      pageSize: 100,
      order: 'createdAt asc'
    }
  });

  const roles = _roles.data.map(function(role, index) {
    return (
      <UserRole key={`role-${index}`} role={role} />
    );
  });

  const jobs = _jobs.data.map(function(job, index) {
    return (
      <UserJob key={`job-${index}`} job={job} />
    );
  });

  const rolesAndJobs = [].concat(roles).concat(jobs).slice(0, MAX_ROLES)

  return (
    <div className="text-sm text-cs-gray-500 text-center">
      {rolesAndJobs.map(function(roleJob, index) {
        return [
          roleJob,
          index < rolesAndJobs.length - 1 ? <span key={`dot-${index}`}>{' • '}</span> : null
        ];
      })}
    </div>
  );
}
